import { NewMatchCommon } from '@/components/add-match'

export const ClubEditMatch = () => {
  return <NewMatchCommon isClubMatch />
}
